import { render } from "./Catalog.vue?vue&type=template&id=22901090&scoped=true"
import script from "./Catalog.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalog.vue?vue&type=script&setup=true&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=22901090&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22901090"],['__file',"resources/js/components/whatsapp-managment/includes/types/Catalog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22901090"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22901090', __exports__)) {
    console.log('reload')
    api.reload('22901090', __exports__)
  }
  
  module.hot.accept("./Catalog.vue?vue&type=template&id=22901090&scoped=true", () => {
    console.log('re-render')
    api.rerender('22901090', render)
  })

}


export default __exports__